<template>
  <div class="Subpage">
    <Bigmenu
      :NavStatus="Bignav"
      :Way="0"
      :BackPath="'/A01'"
      :ShowBackBtn="true"
      v-on:cellback="OpenStatus"
      style="z-index: 2"
    ></Bigmenu>
    <div class="frame" style="z-index: -2"></div>
    <Container
      :Type="false"
      :ImgUrl="'A01.png'"
      :ImgUrls="'A02.png'"
      :Container="Container"
      style="z-index: -6"
    ></Container>
  </div>
</template>

<script>
import Bigmenu from "@/components/Bigmenu.vue";
import Back from "@/components/Back.vue";
import Container from "@/components/Container.vue";
export default {
  name: "A0102",
  data() {
    return {
      Bignav: false,
      Container: {
        subtitle: "",
        videosrc: "A0102.mp4",
        title: "簡化臨床工作流程",
        list: [
          {
            body: "當今多達50%的癌症中心面臨人力短缺與醫護倦怠問題。當患者面臨癌症診斷時，時間就是關鍵。正因如此，我們致力於優化患者治療歷程。透過整合影像與治療流程、運用人工智慧技術，並以專業服務支援臨床團隊，我們期望減輕醫護負擔，使其能專注於提供最佳治療方案。"
          },
          {
            body: "當工作流程順暢運作時，照護將會更為人性化，患者也能獲得更為個人化的照護體驗。"
          }
        ]
      }
    };
  },
  components: {
    Back,
    Container,
    Bigmenu
  },
  methods: {
    OpenStatus(v) {
      this.Bignav = v.status;
    }
  }
};
</script>
<style lang="scss" scoped>
.Subpage {
  height: 100%;
  width: 100%;
}
.frame {
  position: absolute;
  background-image: url("../../assets/frame.png");
  background-position: center;
  height: 1080px;
  width: 1920px;
}
</style>
